<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import Speech from 'speak-tts'
import canAutoPlay from 'can-autoplay'
import { reminder } from '@/api/common'

export default {
  name: 'layout',
  data () {
    return {
      speech: null
    }
  },
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  async created() {
    this.speech = new Speech()
    await this.speech.setLanguage('zh-CN')
    await this.speech.init().then(() => {})
    await this.checkCanAutoPlay()
  },
  methods: {
    checkCanAutoPlay() {
      canAutoPlay.audio().then(({ result }) => {
        console.log(result)
        if (result) {
          this.checkOrder()
        } else {
          this.$alert(
            "监测到您的浏览器不支持自动播放，是否同意播放音频",
            "提示",
            {
              confirmButtonText: "确定",
              callback: (action) => {
                this.checkOrder()
              }
            }
          )
        }
      })
    },
    async checkOrder() {
      const {code, data} = await reminder({orderType: 0})
      if (data) {
        this.play(0)
      }
      setTimeout(async () => {
        const {datas} = await reminder({orderType: 1})
        if (datas) {
          this.play(1)
        }
      }, 5000);
      setTimeout(() => {
        this.checkOrder()
      }, 30 * 1000)
    },
    play(type) {
      let str = ''
      if (type === 1) {
        str = '您好，有提现订单，请及时处理'
      } else {
        str = '您好，有充值订单，请及时处理'
      }
      this.speech.speak({text: str}).then(() => {})
    }
  },
  destroyed() {
    this.speech.cancel()
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue